import { useNavigate, useParams } from '@/router';

export const useEditCoverageTagDismiss = () => {
  const { id } = useParams('/drugs/:id/coverage-tags');
  const navigate = useNavigate();

  return () => navigate('/drugs/:id/coverage-tags', { params: { id } });
};
